export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9570.64ce300e.jpg";